module.exports = __webpack_public_path__ + "images/index/img07.85182b0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/proimg/yuichi/img07.jpg
// module id = M6Rm
// module chunks = 21